import React from 'react';

import { SVGComponentProps } from './svg.types';

const SharedSVG = ({ stroke = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M2.66663 14.6668H12C12.3536 14.6668 12.6927 14.5264 12.9428 14.2763C13.1928 14.0263 13.3333 13.6871 13.3333 13.3335V5.00016L9.66663 1.3335H3.99996C3.64634 1.3335 3.3072 1.47397 3.05715 1.72402C2.8071 1.97407 2.66663 2.31321 2.66663 2.66683V7.3335"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33337 1.3335V5.3335H13.3334"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66663 12L8.66663 10L6.66663 8"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66663 12V11.3333C2.66663 10.9797 2.8071 10.6406 3.05715 10.3905C3.3072 10.1405 3.64634 10 3.99996 10H7.99996"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SharedSVG;
